module.exports = __webpack_public_path__ + "img/test_barcode.136c1dd1.svg";